import React from 'react';
import { Moon, AlertTriangle, Coffee } from 'lucide-react';
import { motion } from 'framer-motion';
export function RealitySection() {
  const cards = [{
    icon: <Moon className="w-8 h-8 text-orange" data-id="element-189" />,
    title: 'El Insomnio Silencioso',
    desc: 'Te acuestas agotado pero tu mente sigue girando como un motor. Despiertas a las 3 AM pensando en un Excel que no existe todavía.'
  }, {
    icon: <AlertTriangle className="w-8 h-8 text-orange" data-id="element-190" />,
    title: 'La Irritabilidad Permanente',
    desc: 'Llegas a casa y no tienes paciencia para tus hijos, tu pareja o tus amigos. Estás presente físicamente, pero mentalmente sigues en la oficina revisando correos que ya leíste.'
  }, {
    icon: <Coffee className="w-8 h-8 text-orange" data-id="element-191" />,
    title: 'El Agotamiento Crónico',
    desc: 'Tu único alivio es el cuarto café del día, que solo te da taquicardia y más ansiedad. El ciclo nunca termina.'
  }];
  return <section className="py-20 bg-navy-50" data-id="element-192">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-193">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-194">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-navy mb-6" data-id="element-195">
            La Realidad del Trabajador Chileno
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed" data-id="element-196">
            En Chile trabajamos más horas que casi cualquier país del mundo.
            Vivimos bajo la presión de agradecer que tenemos pega mientras el
            costo de la vida sube y nuestro tiempo libre desaparece.
          </p>
          <p className="text-lg font-semibold text-navy mt-4" data-id="element-197">
            Esto es lo que estás viviendo hoy:
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-198">
          {cards.map((card, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-199">
              <div className="bg-orange-50 w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-200">
                {card.icon}
              </div>
              <h3 className="font-heading text-xl font-bold text-navy mb-4" data-id="element-201">
                {card.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-202">{card.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-navy text-white p-8 md:p-10 rounded-2xl text-center max-w-4xl mx-auto shadow-xl" data-id="element-203">
          <p className="text-xl md:text-2xl font-medium leading-relaxed" data-id="element-204">
            Si sigues así, el Burnout no es una posibilidad.{' '}
            <span className="text-orange font-bold" data-id="element-205">Es una certeza.</span> Y el
            sistema de salud no te va a salvar. Solo te dará una licencia médica
            y un fármaco para dormir el síntoma, no para solucionar el problema
            de raíz.
          </p>
        </motion.div>
      </div>
    </section>;
}